import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@entities/session';
import { ForgotPasswordPage } from '@pages/forgot-password';
import { PageTransition } from '@ui';

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions).catch(() => null);
    if (user) throw redirect({ to: '/' });
  },
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  return (
    <PageTransition>
      <ForgotPasswordPage />
    </PageTransition>
  );
}
